import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '../../../common/Card';
import styles from './CriticalSystems.module.css';

export const CriticalSystems = ({ category, status }) => {
  const statusClass =
    status === 'Healthy'
      ? styles.healthy
      : status === 'Warning'
      ? styles.warning
      : styles.critical;

  return (
    <Card className={styles.criticalSystem}>
      <div className={styles.row}>
        <h3 className={styles.category}>{category}</h3>
        <p className={`${styles.status} ${statusClass}`}>{status}</p>
      </div>
    </Card>
  );
};

CriticalSystems.propTypes = {
  category: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};
